import React, { useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { AppContext } from '../../../contexts/AppContext';
import { NavLink } from 'react-router-dom';
import './Agenda.css';

const Agenda = () => {
    const intl = useIntl();
    const { langSpanish } = useContext(AppContext);
    
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('theme-event-planned');
        return () => {
            document.body.classList.remove('theme-event-planned');
        };
    }, []);

    const getImage = (imgPath) => {
        if (!imgPath) return '';
        try {
            const cleanPath = imgPath.replace(/^\.\//, '');
            const req = require(`../styles/img/${cleanPath}`);
            return req.default || req;
        } catch (e) {
            console.error("Image not found:", imgPath);
            return '';
        }
    };

    const titlePage = intl.formatMessage({ id: 'eventPlannedAgendaPageTitle', defaultMessage: 'Agenda' });
    const itemsStr = intl.formatMessage({ id: 'eventPlannedAgendaItems', defaultMessage: '[]' });
    
    let items = [];
    try {
        items = JSON.parse(itemsStr);
    } catch (e) {
        console.error("Failed to parse agenda items", e);
    }

    const isItemLive = (item) => {
        // Feature flag para apagar los en vivo
        return false;
        
        if (!item.outlookLink) return false;
        const startMatch = item.outlookLink.match(/startdt=([^&]+)/);
        const endMatch = item.outlookLink.match(/enddt=([^&]+)/);
        if (startMatch && endMatch) {
            const start = new Date(startMatch[1]);
            const end = new Date(endMatch[1]);
            const now = new Date();
            return now >= start && now <= end;
        }
        return false;
    };

    return (
        <div className="supercontent agenda" id="myApp">
            <section className="herowelcome">
                <img className="bck" src={require('../styles/img/backgroundNV1.png')} alt="Background" />
                
                <section className="sectagenda">
                    <div className="superboxponentes" style={{paddingBottom: '80px'}}>
                        
                        {/* Hidden breadcrumbs but preserving space if needed */}
                        <div className="agendatext mt-5 pt-5" style={{ display: 'none' }}>
                            {titlePage}
                        </div>
                        <div className="breadcrumbs" style={{ visibility: 'hidden', marginBottom: '10px' }}>
                            <NavLink to="/event-planned">Inicio</NavLink> &gt; <span>Agenda</span>
                        </div>
                        
                        <div style={{ width: '100%', maxWidth: '1400px', margin: '0 auto', textAlign: 'center', padding: '0 20px' }}>
                            <h2 style={{ color: '#365b6b', fontSize: '26px', fontWeight: 'bold', marginBottom: '15px', textTransform: 'uppercase' }}>
                                ORGANIZACIONES <span style={{ color: '#8cb8d0' }}>POSITIVAS</span> BIENESTAR COMO <span style={{ color: '#8cb8d0' }}>VENTAJA COMPETITIVA</span>
                            </h2>
                            {langSpanish ? (
                                <p style={{ color: '#365b6b', fontSize: '18px', lineHeight: 1.5, marginBottom: '40px' }}>
                                    Consulta el programa completo de Wellbeing 360 en su capítulo de Organizaciones Positivas y agenda en tu calendario las actividades a las que te unirás.
                                </p>
                            ) : (
                                <p style={{ color: '#365b6b', fontSize: '18px', lineHeight: 1.5, marginBottom: '40px' }}>
                                    Check out the complete Wellbeing 360 program for the Purpose-driven Organizations chapter and schedule the activities you will join.
                                </p>
                            )}
                        </div>

                        <div className="tabs-container" style={{ width: '100%', maxWidth: '1400px', margin: '0 auto', padding: '0 20px' }}>
                            <div className="tabs-block">
                                <div id="tabs-section" className="tabs" style={{ padding: '0 20px' }}>
                                    
                                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <div style={{ 
                                            backgroundColor: '#77b6e3', 
                                            color: '#fff', 
                                            padding: '10px 25px', 
                                            fontSize: '14px', 
                                            fontWeight: 'bold',
                                            display: 'inline-block',
                                            textAlign: 'center',
                                            minWidth: '150px',
                                            marginBottom: '1px'
                                        }}>
                                            Día 1<br/>
                                            {langSpanish ? '08/Oct/2026' : '08/Oct/2026'}
                                        </div>
                                    </div>

                                    <div className="tab-body" style={{ 
                                        display: 'block', 
                                        backgroundColor: '#77b6e3', 
                                        padding: '0'
                                    }}>
                                        {items.map((item, idx) => (
                                            <div className="itemagend custom-grid" key={idx} style={{ 
                                                borderBottom: idx === items.length - 1 ? 'none' : '1px solid #365b6b',
                                                padding: '40px 0',
                                                margin: '0',
                                            }}>
                                                <div className="grid-photo">
                                                    {item.imageSrc ? (
                                                        <img src={getImage(item.imageSrc)} alt={item.speakers} style={{borderRadius: '50%', width: '120px', height: '120px', objectFit: 'cover', border: '3px solid #365b6b'}} />
                                                    ) : (
                                                        <div style={{width: '120px', height: '120px', backgroundColor: '#365b6b', borderRadius: '50%', border: '3px solid #365b6b'}}></div>
                                                    )}
                                                </div>
                                                
                                                <div className="grid-time">
                                                    <h4 className="time" style={{ 
                                                        backgroundColor: '#195663', 
                                                        color: '#fff', 
                                                        borderRadius: '20px', 
                                                        padding: '6px 20px',
                                                        margin: '0',
                                                        fontSize: '14px',
                                                        display: 'inline-block',
                                                        textAlign: 'center'
                                                    }}>
                                                        {item.time}
                                                    </h4>
                                                    {isItemLive(item) && (
                                                        <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                                            <NavLink to="/organizaciones-con-proposito/live" style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                padding: '4px 12px',
                                                                borderRadius: '20px',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px',
                                                                textDecoration: 'none',
                                                                display: 'inline-block',
                                                                animation: 'pulse 2s infinite'
                                                            }}>
                                                                🔴 {intl.formatMessage({ id: 'navEventPlannedLive', defaultMessage: 'Estamos En Vivo' })}
                                                            </NavLink>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="grid-info">
                                                    <h3 className="title" style={{ color: '#365b6b', fontSize: '24px', fontWeight: 'bold', margin: '0 0 5px 0', padding: '0' }}>
                                                        {item.title}
                                                    </h3>
                                                    <h4 className="sub-title" style={{ color: '#365b6b', fontSize: '16px', margin: '0 0 5px 0', padding: '0' }}>
                                                        {item.duration}
                                                    </h4>
                                                    
                                                    {item.speakers && (
                                                        <div className="enlacelive3" style={{ padding: '0', marginTop: '10px' }}>
                                                            <span style={{ color: '#365b6b', fontSize: '16px', padding: '0', whiteSpace: 'pre-line' }}>{item.speakers}</span>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="grid-buttons">
                                                    {item.gcalLink && (
                                                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                            <a href={item.outlookLink} target="_blank" rel="noreferrer" style={{
                                                                display: 'flex', alignItems: 'center', backgroundColor: '#587c95', color: '#fff', padding: '8px 15px', borderRadius: '5px', fontSize: '12px', textDecoration: 'none', border: '1px solid #fff'
                                                            }}>
                                                                <div style={{ backgroundColor: '#0072c6', color: '#fff', padding: '2px 6px', borderRadius: '3px', marginRight: '8px', fontWeight: 'bold' }}>O</div>
                                                                {langSpanish ? "Agregar a Outlook" : "Add to Outlook"}
                                                            </a>
                                                            <a href={item.gcalLink} target="_blank" rel="noreferrer" style={{
                                                                display: 'flex', alignItems: 'center', backgroundColor: '#587c95', color: '#fff', padding: '8px 15px', borderRadius: '5px', fontSize: '12px', textDecoration: 'none', border: '1px solid #fff'
                                                            }}>
                                                                <img src="/evento/img/icon-gcalendar.svg" alt="" style={{ width: '16px', marginRight: '8px' }} />
                                                                {langSpanish ? "Agregar a Gmail" : "Add to Gmail"}
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
};

export default Agenda;
